import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ErrorPage, KivraTheme } from "@kivra/react-components";
import "./globalModule";
import { App } from "./App";
import { bootstrap } from "./bootstrap";
import type { AppProps } from "./types";
import { captureException } from "@kivra/sdk/log/sentry-react";

// Safari and firefox has back/forward cache, reload page
// https://web.dev/bfcache/

// https://developer.mozilla.org/en-US/docs/Web/API/PageTransitionEvent/persisted

window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});

function renderApp({
  store,
  scheme,
  history,
  config,
  lang,
  initLang,
  isDirectLoginRedirect,
}: AppProps) {
  if (isDirectLoginRedirect) {
    return; // don't start to render app if redirect is happening
  }
  const container = document.getElementById("root")!;
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <KivraTheme colorScheme={scheme}>
        <App
          history={history}
          config={config}
          lang={lang}
          initLang={initLang}
        />
      </KivraTheme>
    </Provider>,
  );
}

bootstrap()
  .then((props) => {
    renderApp(props);
  })
  .catch((error) => {
    console.log("error", error);
    const eventId = captureException(error);
    const container = document.getElementById("root")!;
    const root = createRoot(container);

    root.render(
      <ErrorPage useDefaultTexts exceptionId={eventId} market="fi" />,
    );
  });
